import { MutationTree } from "vuex";
import { OpenAccountInvoiceType, OpenAccountState } from "@/feature/OpenAccount/store/interface";
import { OpenAccountMutation } from "@/feature/OpenAccount/store/constants";
import ObjectUtils from "@/modules/Object/ObjectUtils";

export default <MutationTree<OpenAccountState>> {

	[OpenAccountMutation.setInvoiceList]: (
		state,
		invoiceList: OpenAccountState['invoiceList']
	) => {
		state.invoiceList = invoiceList;
	},

	[OpenAccountMutation.setInvoice]: (
		state,
		invoice: OpenAccountState['invoice']
	) => {
		if (invoice?.applicationStatus === OpenAccountInvoiceType.OPEN) {
			state.invoice = ObjectUtils.assign(
				state.invoice, invoice
			);
		} else {
			for (let i = 0; i < state.invoiceList.length; i++) {
				if (state.invoiceList[i]?.applicationNumber === invoice?.applicationNumber) {
					state.invoiceList[i] = ObjectUtils.assign(
						state.invoiceList[i], invoice
					);

					break;
				}
			}
		}
	},

	[OpenAccountMutation.setStep]: (
		state,
		step: OpenAccountState['step']
	) => {
		state.step = step;
	},

	[OpenAccountMutation.setRequestData]: (
		state,
		requestData: Partial<OpenAccountState['requestData']>
	) => {
		state.requestData = ObjectUtils.assign(
			state.requestData, requestData
		);
	},

	[OpenAccountMutation.setPhoneNumber]: (
		state,
		phoneNumber: OpenAccountState['phoneNumber']
	) => {
		state.phoneNumber = phoneNumber;
	},

	[OpenAccountMutation.setLegalEntity]: (
		state,
		legalEntity: OpenAccountState['legalEntity']
	) => {
		state.legalEntity = legalEntity;
	},

	[OpenAccountMutation.setLegalEntityLoading]: (
		state,
		legalEntityLoading: OpenAccountState['legalEntityLoading']
	) => {
		state.legalEntityLoading = legalEntityLoading;
	},

	[OpenAccountMutation.setLegalEntityLoadingHint]: (
		state,
		legalEntityLoadingHint: OpenAccountState['legalEntityLoadingHint']
	) => {
		state.legalEntityLoadingHint = legalEntityLoadingHint;
	},

}